module.exports = __webpack_public_path__ + "static/media/close-circle.cc9a41d8.svg";